var React = require('react');

function Cross (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 1L13 13M1 13L13 1L1 13Z","stroke":"#4C5866","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Cross.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = Cross;

Cross.default = Cross;
